<div class="reviews">
  <div class="close" *ngIf="fromDialog">
    <app-clear-button (closeButton)="close()"></app-clear-button>
  </div>

  <div class="review_content flex h_100">
    <div class="review_content--left h_100">
      <div class="review_content--left--title" *ngIf="data.product">
        {{data.product.title}}
      </div>

      <div class="flex_column number_and_shop">
        <div class="rating_number mt_24" *ngIf="data.product">
          <div class="sub_info_rate">
            Общая оценка
          </div>
          <div class="flex_align_center">
            <img src="assets/images/icons/shops/star_for_shop.svg">
            <span class="ml_4 number" >
              {{data.product.productAverageRate | number: '0.2-2' | replaceToComma}}
             </span>
          </div>
        </div>
        <div class="flex_column shop_container">
          <div class="shop_view flex_between_align_center pointer">
            <div class="shop_info flex_align_center">
              <div class="shop_logo" [ngClass]="{'default_image flex_center_align_center':!data.shop.imageUrl}">
                <img [src]="data.shop.imageUrl || 'assets/images/icons/shops/shop-default.svg'"
                     [ngClass]="{'logo_img':data.shop.imageUrl}">
              </div>
              <div class="flex_column ml_12">
                  <span class="text_normal_sub bold_700">
                    {{ data.shop.shopName }}
                  </span>
                <span class="shop_description">
                    {{ data.shop?.description }}
            </span>
              </div>
            </div>
          </div>
          <div class="flex_align_center mt_12 block_rat">
            <div class="flex_align_center rating_number">
              <img src="assets/images/icons/shops/star_for_shop.svg">
              <div class="number ml_4">
                {{data.shop.shopAverageRate | number: '0.2-2' | replaceToComma}}
              </div>
            </div>
            <div class="pay_bonus">
              <div class="pay_bonus--text">
                Оплата баллами {{data.shop.bonusDeduction}}%
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="review_content--right w_100 h_100">
      <div class="review_content--right--header" >
        @if (data.product) {
          {{data.product.rateCount}} оценок
        } @else {
          {{data.shop.rateCount}} оценок
        }
      </div>

      <div class="list_of_reviews">
        <div class="list_of_reviews--item" *ngFor="let review of reviews">
          <div class="list_of_reviews--item--user flex">
              <img [src]="review.userImageUrl || 'assets/images/icons/profile/default_picture.svg'" class="profile_pic">
              <div class="info">
                <div class="info--name">{{review.user || 'Аноним'}}</div>
                <div class="info--date">{{review.createdAt | toLocalDate : 'DD MMMM'}}</div>
              </div>
          </div>
          <div class="flex_align_center rate">
            <img src="assets/images/icons/shops/star_for_shop.svg">
            <span class="ml_4 number" >
                {{review.rating | number: '0.2-2' | replaceToComma}}
               </span>
          </div>

          @if (review.resources.length) {
            <div class="resources flex" (click)="openGallery(review.resources)">
              @for (resource of review.resources; track resource.id) {
                <div class="image">
                  <img class="original" [src]="resource.imageResourceUrl">
                  <img class="play" [src]="'assets/images/icons/play.svg'">
                </div>
              }
            </div>
          }

          <div class="comment" [class.no_comment]="!review.feedback">
            @if (review.feedback) {
                {{review.feedback}}
            } @else {
              *Пользователь не оставил комментария
            }
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
